import React, { useContext } from "react";
import cx from "classnames";
import { Carousel } from "react-responsive-carousel";

// @styles
import "./styles.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Progress, Tooltip } from "antd";
import { Gauge } from "@ant-design/charts";
import { AppContext } from "../../contexts/global";
import { getColorIndicator, getColorNps, validateDirectivas,changeUrl } from "../../utils/utils";

export default function Indicators({ items, data, indicatorInfo }) {
  const { user,directivas } = useContext(AppContext);
  const indicatorsByUser = items;
  const config = {
    percent: indicatorInfo && (indicatorInfo.cumplimiento_acumulado | indicatorInfo.resultado_pto_cumplimiento_mensual) / 100,
    range: {
      color: indicatorInfo && (getColorIndicator(indicatorInfo.cumplimiento_acumulado | indicatorInfo.resultado_pto_cumplimiento_mensual)),
      width: 12,
    },
    startAngle: Math.PI,
    endAngle: 2 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        offsetY: -36,
        style: {
          fontSize: "25px",
          lineHeight: "44px",
          color: "#FFF",
        },
        formatter: () => { return indicatorInfo && indicatorInfo.ventas_acumuladas },
      },
      content: {
        style: {
          fontSize: "24px",
          lineHeight: "44px",
          color: "#FFF",
        },
        formatter: () => { return indicatorInfo && `${(indicatorInfo.cumplimiento_acumulado | indicatorInfo.resultado_pto_cumplimiento_mensual)}%` },
      },
    },
    style: {
      width: "100%",
      height: 130,
    },
  };

  const npsVenta = {
    percent: indicatorInfo && (indicatorInfo.nps_venta / 100),
    range: {
      color: indicatorInfo && (getColorNps(indicatorInfo.nps_venta)),
      width: 8,
    },
    indicator: null,
    statistic: {
      title: {
        offsetY: -36,
        style: {
          fontSize: "25px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { return indicatorInfo && (indicatorInfo.nps_venta) },
      },
      content: {
        style: {
          fontSize: "24px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { },
      },
    },
    style: {
      width: "100%",
      height: 100,
    },
  };

  const posventa = {
    percent: indicatorInfo && (indicatorInfo.nps_post_venta / 100),
    range: {
      color: indicatorInfo && (getColorNps(indicatorInfo.nps_post_venta)),
      width: 8,
    },
    indicator: null,
    statistic: {
      title: {
        offsetY: -36,
        style: {
          fontSize: "25px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { return indicatorInfo && (indicatorInfo.nps_post_venta) },
      },
      content: {
        style: {
          fontSize: "24px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { },
      },
    },
    style: {
      width: "100%",
      height: 100,
    },
  };

  const leadsVenta = {
    percent: indicatorInfo && (indicatorInfo.nps_leads_valor / 100),
    range: {
      color: indicatorInfo && (getColorNps(indicatorInfo.nps_leads_valor)),
      width: 8,
    },
    indicator: null,
    statistic: {
      title: {
        offsetY: -36,
        style: {
          fontSize: "25px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { return indicatorInfo && (indicatorInfo.nps_leads_valor) },
      },
      content: {
        style: {
          fontSize: "24px",
          lineHeight: "44px",
          color: "#4B535E",
        },
        formatter: () => { },
      },
    },
    style: {
      width: "100%",
      height: 100,
    },
  };

  return (
    <div className="indicators-content">
      {indicatorsByUser.map(
        (indicator, index) =>
          validateDirectivas(directivas, indicator.primary.id) && (
            <article
              className={cx("indicators-item", {
                "indicators-item-small": indicator.primary.design === "Pequeño",
                "indicators-item-big": indicator.primary.design === "Grande",
              })}
              key={`indicators-${index}`}
              id={indicator.primary.id}
            >
              <Carousel
                showIndicators={false}
                showStatus={false}
                showThumbs={false}
                swipeable
              >
                {indicator.items.map((item, k) => (
                  <div
                    key={`indicators-item-${k}`}
                    className={cx({
                      "indicators-item-vertical":
                        item.orientation === "Vertical",
                      "indicators-item-horizontal":
                        item.orientation === "Horizontal",
                    })}
                  >
                    <div className="indicators-item-content">
                      <div className="indicators-item-groupname">
                        {item.type === "Edukando"
                          ? <>{item.type}
                            <a
                              href={process.env.URL_BASE_EDUKANDO_LABTICA_AUTH}
                              target="_blank"
                              onClick={(event) => {
                                changeUrl(event, process.env.URL_BASE_EDUKANDO_LABTICA_AUTH, "modulo.edukando", user);
                              }}
                            >
                              Ver más
                            </a></>
                          :
                          item.type
                        }
                      </div>
                      <div className="indicators-item-message">
                        {item.type === "Edukando"
                          ? <>Has completado el <strong>{data["Edukando"] ? data["Edukando"] : '0'}%</strong> de tus cursos</>
                          : item.message}
                      </div>
                    </div>
                    <div className="indicators-item-chart">
                      {item.powerbi && <div>powerbi</div>}
                      {!item.powerbi && item.id === "indicadorEdukando" && (
                        <div className="indicators-item-chart-content">
                          <div className="indicators-item-chart-content-marker">
                            <Tooltip title='Meta mínima' overlayClassName="tooltip-custom"><p className="indicators-item-chart-content-marker-item">60%</p></Tooltip>
                          </div>
                          <Progress
                            percent={data["Edukando"]}
                            showInfo={false}
                            className={data["Edukando"] > 59 ? 'progress-success' : 'progress-danger'}
                          />
                        </div>
                      )}
                      {!item.powerbi && item.id === "npsVenta" && indicatorInfo && indicatorInfo.nps_venta != null && (
                        <div className="indicators-item-chart-content">
                          <Gauge {...npsVenta} />
                          <div className="indicators-item-chart-content-gauge-number small-number c-1">
                            <p>0.0</p>
                            <p>100.0</p>
                          </div>
                        </div>
                      )}
                      {!item.powerbi && item.id === "npsTecnico" && indicatorInfo && indicatorInfo.nps_post_venta != null && (
                        <div className="indicators-item-chart-content">
                          <Gauge {...posventa} />
                          <div className="indicators-item-chart-content-gauge-number small-number c-1">
                            <p>0.0</p>
                            <p>100.0</p>
                          </div>
                        </div>
                      )}
                      {!item.powerbi && item.id === "npsLeads" && indicatorInfo && indicatorInfo.nps_leads_valor != null && (
                        <div className="indicators-item-chart-content">
                          <Gauge {...leadsVenta} />
                          <div className="indicators-item-chart-content-gauge-number small-number c-1">
                            <p>0.0</p>
                            <p>100.0</p>
                          </div>
                        </div>
                      )}
                      {!item.powerbi && item.id === "ventaMes" && (
                        <div className="indicators-item-chart-content">
                          <Gauge {...config} />
                          <div className="indicators-item-chart-content-gauge-number c-wh">
                            <p>0</p>
                            <p>{indicatorInfo && (indicatorInfo['presupuesto_mensual_tienda'] | indicatorInfo.resultado_pto_diario_asesor)}</p>
                          </div>
                        </div>
                      )}
                      {!item.powerbi && item.id === "objetivoDia" && (
                        <div className="indicators-item-chart-content">
                          <strong className="indicators-item-chart-content-cifra">
                            {indicatorInfo && indicatorInfo.presupuesto_acumulado_tienda | indicatorInfo.meta_acumulada}
                          </strong>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </Carousel>
            </article>
          )
      )}
    </div>
  );
}
